import type { RecipientGroupType } from '@api';
import type { RecipientGroupFormValuesType } from '@common';

export const mapRecipientGroupToFormValues = (
  group: RecipientGroupType
): RecipientGroupFormValuesType => ({
  label: group.label,
  recipients: [
    ...group.personRecipients.map(({ emailField, person }) => ({
      kind: 'PERSON' as const,
      personId: person.id,
      name: `${person.firstname} ${person.lastname}`,
      email: person.email,
      company: person.companyLink.name,
      emailField,
    })),
    ...group.customRecipients.map(({ name, email, emailField }) => ({
      kind: 'CUSTOM' as const,
      name,
      email,
      emailField,
    })),
  ],
});
